import API from '../dataApi';

// -- Accounting: Payment Vouchers ----------------------------------------------
export const getPaymentVouchers = (params) => API.get('/payments', { params });
export const createPaymentVoucher = (data) => API.post('/payments', data);
export const getPaymentVoucher = (id) => API.get(`/payments/${id}`);
export const cancelPaymentVoucher = (id, reason) => API.delete(`/payments/${id}`, { data: { reason } });
export const downloadVoucherPDF = (id) => API.get(`/payments/${id}/pdf`, { responseType: 'blob' });
export const sendVoucherEmail = (id) => API.post(`/payments/${id}/send-email`);
export const getExpenseTypes = (derasarId) => API.get('/payments/expense-types', { params: { derasarId } });
export const createExpenseType = (data) => API.post('/payments/expense-types', data);
export const updateExpenseType = (id, data) => API.put(`/payments/expense-types/${id}`, data);
export const updatePaymentVoucher = (id, data) => API.put(`/payments/${id}`, data);
